import { registerLocaleData } from '@angular/common'
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'
import localePt from '@angular/common/locales/pt'
import { DoBootstrap, inject, Injector, LOCALE_ID, NgModule, provideAppInitializer } from '@angular/core'
import { createCustomElement } from '@angular/elements'
import { MAT_DATE_LOCALE } from '@angular/material/core'
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { BrowserModule } from '@angular/platform-browser'
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations'
import { TranslateModule } from '@ngx-translate/core'
import { CustomElementsEnum } from './app.type'
import { AlertComponent } from './core/components/alert/alert.component'
import { AccessTokenInterceptor } from './core/interceptors/authentication.interceptor'
import { provideApollo } from './core/providers/apollo-providers'
import { TranslationLoaderService } from './core/services/i18n/i18n.service'
import { AssetsTreeComponent } from './elements/assets-tree/assets-tree.component'
import { CreateOrEditPendencyDialogComponent } from './elements/create-or-edit-pendency-dialog/create-or-edit-pendency-dialog.component'
import { FcMaintenanceSelectComponent } from './elements/fc-maintenance-select/fc-maintenance-select.component'
import { FcSelectMultiplePagedComponent } from './elements/fc-select-multiple-paged/fc-select-multiple-paged.component'
import { FcSelectPagedComponent } from './elements/fc-select-paged/fc-select-paged.component'
import { NgxFieldControlToolbarComponent } from './elements/fc-toolbar/fc-toolbar.component'
import { MaintenanceProductsTabComponent } from './elements/maintenance-products-tab/maintenance-products-tab.component'
import { MaintenanceServicesTabComponent } from './elements/maintenance-services-tab/maintenance-services-tab.component'
import { UpdatePendencyAssigneeModalComponent } from './elements/update-pendency-assignee-modal/update-pendency-assignee-modal.component'
import { EquipmentWarrantiesTabComponent } from './elements/warranties-equipment-tab/warranties-equipment-tab.component'
import { WarrantiesMaintenanceTabComponent } from './elements/warranties-maintenance-tab/warranties.component'
import { GraphqlModule } from '../graphql.module'

registerLocaleData(localePt)

@NgModule({
  schemas: [],
  imports: [
    AlertComponent,
    AssetsTreeComponent,
    BrowserAnimationsModule,
    BrowserModule,
    CreateOrEditPendencyDialogComponent,
    FcMaintenanceSelectComponent,
    FcSelectMultiplePagedComponent,
    FcSelectPagedComponent,
    GraphqlModule,
    MatDialogModule,
    MatProgressBarModule,
    UpdatePendencyAssigneeModalComponent,
    TranslateModule.forRoot({
      defaultLanguage: 'pt-BR',
    })],
  providers: [
    provideApollo(),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    provideAppInitializer(() => {
      const translationLoaderService = inject(TranslationLoaderService)
      translationLoaderService.initialize()
    }),
    { provide: HTTP_INTERCEPTORS, useClass: AccessTokenInterceptor, multi: true },
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    { provide: MatDialogRef, useValue: {} },
    { provide: MAT_DIALOG_DATA, useValue: {} },
  ]
})
export class AppModule implements DoBootstrap {
  public constructor(
    private readonly injector: Injector
  ) {}

  public ngDoBootstrap() {
    const customElementsDefined = [
      { name: CustomElementsEnum.FC_TOOLBAR, component: NgxFieldControlToolbarComponent },
      { name: CustomElementsEnum.ASSETS_TREE_BODY, component: AssetsTreeComponent },
      { name: CustomElementsEnum.FC_SELECT_MULTIPLE_PAGED, component: FcSelectMultiplePagedComponent },
      { name: CustomElementsEnum.FC_SELECT_PAGED, component: FcSelectPagedComponent },
      { name: CustomElementsEnum.FC_MAINTENANCE_SELECT, component: FcMaintenanceSelectComponent },
      { name: CustomElementsEnum.CREATE_OR_EDIT_PENDENCY_BODY, component: CreateOrEditPendencyDialogComponent },
      { name: CustomElementsEnum.UPDATE_PENDENCY_ASSIGNEE_MODAL_BODY, component: UpdatePendencyAssigneeModalComponent },
      { name: CustomElementsEnum.EQUIPMENT_WITH_WARRANTIES, component: EquipmentWarrantiesTabComponent },
      { name: CustomElementsEnum.MAINTENANCE_PRODUCTS_TAB, component: MaintenanceProductsTabComponent },
      { name: CustomElementsEnum.MAINTENANCE_SERVICES_TAB, component: MaintenanceServicesTabComponent },
      { name: CustomElementsEnum.WARRANTIES_MAINTENANCE_TAB, component: WarrantiesMaintenanceTabComponent },
    ]

    for (const customElement of customElementsDefined) {
      if (customElements.get(customElement.name)) {
        console.warn(`Custom element ${customElement.name} already defined`)
      } else {
        const element = createCustomElement(customElement.component, {
          injector: this.injector,
        })
        customElements.define(customElement.name, element)
      }
    }
  }
}
